
export default function MobileViewContainer({ children }: { children: React.ReactNode }) {
    return (
        <div className="flex w-full justify-center layout-wrapper landing bg-white overflow-x-clip">
            <div
                className="flex flex-col w-full shadow-2xl max-w-160 mx-auto bg-white min-h-screen shrink-0 relative"
            >
                {children}
            </div>
        </div>
    )
}
